exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bottom-nav {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.bottom-nav a {\n  background-color: #aaa;\n  padding: 10px;\n  border-radius: 5px;\n  font-size: 15px;\n  text-decoration: none;\n  text-transform: uppercase;\n  color: #fff;\n}\n.bottom-nav a:hover {\n  background-color: #c3c3c3;\n}\n", ""]);

